import { Component, OnInit } from '@angular/core';
import { CurrencyService } from '../currency.service';
import { CurrencyModel } from '../../../common/models/Currency.Model';
import { SettingsService } from '../../../../core/settings/settings.service';
import { ActivatedRoute, Router } from '@angular/router';
import { toNumber } from 'lodash';
import { GlobalFunctionsService } from 'src/app/ceq/common/functions/global-functions.service';

@Component({
  selector: 'app-currency-detail',
  templateUrl: './currency-detail.component.html',
  styleUrls: ['./currency-detail.component.scss']
})
export class CurrencyDetailComponent implements OnInit {

  org: number = 0;
  currency: CurrencyModel = new CurrencyModel();
  isNew: boolean = false;

  constructor(private currencyService: CurrencyService, private globalFunctionService: GlobalFunctionsService, private settings: SettingsService, private url: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    this.org = this.settings.getUser().Org;

    let currentId = this.url.snapshot.paramMap.get('id');

    if (this.isNullOrWhitespace(currentId) || currentId === 'create') {
      this.currency.currencyId = 0;
      this.isNew = true;
    }
    else {
      this.currency.currencyId = toNumber(currentId);
      this.getCurrency();
      this.isNew = false;
    }
  }

  formSubmit(value: any) {
    if (this.currency.currencyId == 0) {
      //Create
      this.currencyService.createCurrency(this.currency).subscribe(async data => {
		    await this.globalFunctionService.messageBimbo('Moneda creada', 'success', '¡Éxito!');
        this.btnCancelOnClick();
      }, async (error) => {
		    await this.globalFunctionService.messageBimbo(error.error, 'error', '¡Error!');
      });
    }
    else {
      //Update
      this.currencyService.updateCurrency(this.org, this.currency).subscribe(async data => {
		    await this.globalFunctionService.messageBimbo('Moneda actualizada', 'success', '¡Éxito!');
        this.btnCancelOnClick();
      }, async (error) => {
		    await this.globalFunctionService.messageBimbo(error.error, 'error', '¡Error!');
      });
    }
  }

  btnCancelOnClick() {
    this.router.navigate(['/tax/currency']);
  }

  getCurrency() {
    this.currencyService.getCurrencyById(this.currency.currencyId).subscribe(data => {
      this.currency = data;
    }, async (error) => {
		  await this.globalFunctionService.messageBimbo("No se encontró la moneda solicitada", 'error', '¡Error!');
      this.btnCancelOnClick();
    });
  }

  isNullOrWhitespace(input) {
    if (typeof input === 'undefined' || input == null) return true;
    return input.replace(/\s/g, '').length < 1;
  }
}
